import React, { useContext, useEffect, useState } from 'react'
import { Form, Field, FormElement } from '@progress/kendo-react-form';
import { Grid } from "@mui/material";
import Stack from "@mui/material/Stack";
import * as yup from "yup";
import Validator from "../../../../../_helpers/validate.schema";
import {
    UiBackButton,
    UiButton,
} from "../../../../_uiComponents/common/form/UiButton";
import UiInput from '../../../../_uiComponents/telerikComponents/UiInput'
import { UiSwitch } from '../../../../_uiComponents/telerikComponents/UiSwitch';
import UiDropDownList from '../../../../_uiComponents/telerikComponents/UiDropDownList';
import { useDispatch } from 'react-redux';
import { contextApiActions, participantConstants } from '../../../../../_redux/_constants';
import { participantGetDealersRequest, participantUpdateDealerRequest } from '../../../../../_redux/_actions';
import { useSelector } from 'react-redux';
import { Context } from '../../../../../_context/Store';

export default function TransferDealer(props) {


    const actionDispatch = useDispatch();
    const [state, dispatch] = useContext(Context);

    const { dealerList } = useSelector((state) => ({
        dealerList: state?.participantsManagement?.dealerList,
    }));

    const [dealer, setDealer] = useState(null)

    useEffect(() => {
        if(props?.currentDealer?.application === participantConstants.PARTICIPANT_APPLICATION_EQUIPE){
            actionDispatch(participantGetDealersRequest({ applicationId: 1 }));
        }if(props?.currentDealer?.application === participantConstants.PARTICIPANT_APPLICATION_TLC){
            actionDispatch(participantGetDealersRequest({ applicationId: 3 }));
        }
    },[props]);

    const dealerValidator = value => value ? '' : 'Dealer is required.';

    const handleSubmit = dataItem => {
        
        actionDispatch(participantUpdateDealerRequest({
            ParticipantId:props?.currentDealer?.id,
            DealershipId:dataItem?.newDealer?.value
        }));

        dispatch({
            type: contextApiActions.UI_MODAL_TOGGEL,
            payload: {
                show: false,
            }
        })
    }
    return (
        <> 
            <Form onSubmit={handleSubmit}
                render={formRenderProps =>
                    <Grid container spacing={2}>
                        <div className="sba-input-areas-wr">
                        <Grid container spacing={2}>
                            <Grid item xs={12} lg={6} sx={{ mt: 1 }} className='sba-dealer-label'>
                              <span><label>Current Dealer</label> 
                              <label>{`${props?.currentDealer?.dealershipCode} | ${props?.currentDealer?.dealershipName}`}</label>
                              </span>  
                            </Grid>
                        </Grid>
                        {dealerList.length > 0 && (
                            <Grid item xs={12} lg={6} sx={{ mt: 1 }}>
                            <Field name={'newDealer'}
                                        component={UiDropDownList}
                                        labelClassName={'k-form-label'}
                                        data={dealerList
                                            .filter((app) => app.name !== props?.currentDealer?.dealershipName)
                                            .map((app) => ({
                                                value: app.id.toString(),
                                                label: app.name,
                                            }))
                                        }
                                        label="New Dealer"
                                        validator={dealerValidator}
                                        value={dealer}
                                        onChange={(e) => setDealer(e.value?.value)} />

                            </Grid>
                        )}
                            <Grid item xs={12}>
                                <Stack
                                    spacing={2}
                                    direction="row"
                                    justifyContent="space-between"
                                    sx={{ width: "100%", mt: 1.5 }}
                                >
                                    <div className="sbt-right-action-btn-wr">                                  
                                        <UiButton
                                                name="Cancel"
                                                variant="outlined"
                                                size="small"
                                                onClick={formRenderProps.onFormReset}
                                            />
                                        <UiButton
                                            name="Transfer"
                                            variant="contained"
                                            size="small"
                                            onClick={formRenderProps.onSubmit}
                                            disabled={!formRenderProps.allowSubmit}
                                        />

                                    </div>
                                </Stack>
                            </Grid>
                        </div>
                    </Grid>
                }
            />
        </>
    )
}
